import React, { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import CoverPage from "../../components/CoverPage";
import { MainNavUser } from "../../components/header/MainNavUser";
import { FooterUser } from "../../components/footer/FooterUser";
import { ErrorView } from "../../pages/error/ErrorView";
import { toolService } from '../../services'
import imgCoverPage from '../../assets/images/figure/data-storage.svg';
import imgCloudDataProcess from '../../assets/images/figure/data-process.svg';
import imgCloudOnlineReport from '../../assets/images/figure/online-report.svg';
import imgCloudDataAnalytics from '../../assets/images/figure/data-analytics.svg';
import '../../assets/scss/style.scss';

export const CloudAccounting = () => {

  let title = "Cloud accounting services - Our Services";
  document.title = title + ' | SNHA P.C';

  const [mainHeader, setMainHeader] = useState({
    layer: "",
    title: "",
    subtitle: "",
  });
  const [sectionOne, setSectionOne] = useState({
    paragraph: "",
  });
  const [sectionTwoSubOne, setSectionTwoSubOne] = useState({
    title: "",
    paragraph: "",
  });
  const [sectionTwoSubTwo, setSectionTwoSubTwo] = useState({
    title: "",
    paragraph: "",
  });
  const [sectionTwoSubThree, setSectionTwoSubThree] = useState({
    title: "",
    paragraph: "",
  });
  const [sectionThree, setSectionThree] = useState({
    title: "",
    paragraph: "",
    extraData: [{
      delay: "",
      title: "",
    }],
  });

  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const sectionMain = async () => {
      setError(null);
      setIsLoaded(true);
      try {
        const response = await toolService.getLayerSection('cloud-accounting-services')
        const mainHeaderData = {
          layer: "CLOUD-ACCOUNTING-SERVICES",
          title: response.data.data.mainHeader.mainHeaderTitle,
          subtitle: response.data.data.mainHeader.mainHeaderSubtitle,
        };
        setMainHeader(mainHeaderData);
        response.data.data.layerSections.forEach((section) => {
          const subsection = section.subSections[0];
          const subSection = {};
          if (subsection.subSectionTitle) {
            subSection["title"] = subsection.subSectionTitle;
          }
          if (subsection.subSectionParagraph) {
            subSection["paragraph"] = subsection.subSectionParagraph;
          }
          subSection["extraData"] = [];
          subsection.subSectionExtraData.forEach((extradata) => {
            const extraData = {};
            if (extradata.extraDataDelay) {
              extraData["delay"] = extradata.extraDataDelay;
            }
            if (extradata.extraDataTitle) {
              extraData["title"] = extradata.extraDataTitle;
            }
            subSection.extraData.push(extraData);
          });

          if (section.subSections[1]) {
            const subsectionExtraTwo = section.subSections[1];
            const subSectionExtraTwo = {};
            if (subsectionExtraTwo.subSectionTitle) {
              subSectionExtraTwo["title"] = subsectionExtraTwo.subSectionTitle;
            }
            if (subsectionExtraTwo.subSectionParagraph) {
              subSectionExtraTwo["paragraph"] = subsectionExtraTwo.subSectionParagraph;
            }
            setSectionTwoSubTwo(subSectionExtraTwo);
          }
          if (section.subSections[2]) {
            const subsectionExtraThree = section.subSections[2];
            const subSectionExtraThree = {};
            if (subsectionExtraThree.subSectionTitle) {
              subSectionExtraThree["title"] = subsectionExtraThree.subSectionTitle;
            }
            if (subsectionExtraThree.subSectionParagraph) {
              subSectionExtraThree["paragraph"] = subsectionExtraThree.subSectionParagraph;
            }
            setSectionTwoSubThree(subSectionExtraThree);
          }

          switch (section.sectionName) {
            case "SECTION_ONE":
              setSectionOne(subSection);
              break;
            case "SECTION_TWO":
              setSectionTwoSubOne(subSection);
              break;
            case "SECTION_THREE":
              setSectionThree(subSection);
              break;
            default:
              break;
          }
        });
      } catch (error) {
        setError(error);
        console.log(error);
      }
      setIsLoaded(false);
    }
    sectionMain();
  }, []);

  if (isLoaded) {
    return (
      <div className="loader">
        <ReactLoading type={'bubbles'} color={'#112349'} height={100} width={100} className="d-flex mx-auto" />
        <h5>Loading...</h5>
      </div>
    )
  } else {
    if (error) {
      return (<ErrorView />)
    } else {
      return (
        <div>
          <MainNavUser />
          <CoverPage data={mainHeader} img={imgCoverPage} />
          <main role='main' className='flex-shrink-0 content'>

            <section id="about" className="about section-bg">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 d-flex flex-column justify-contents-center" data-aos="fade-left">
                    <div className="content pt-4 pt-lg-0">
                      <p className="paragraph">{sectionOne.paragraph} </p>
                    </div>
                  </div>
                </div>

              </div>
            </section>
            <section id="details" className="details">
              <div className="container">
                <div className="row content">
                  <div className="col-md-4 order-1 order-md-2" data-aos="fade-left">
                    <img src={imgCloudDataProcess} className="img-fluid animated" alt="img-cloud--data-process" />
                  </div>
                  <div className="col-md-8 order-2 order-md-1" data-aos="fade-up">
                    <h3>{sectionTwoSubOne.title}</h3>
                    <p className="paragraph">{sectionTwoSubOne.paragraph} </p>
                  </div>
                </div>

                <div className="row content mt-0">
                  <div className="col-md-4" data-aos="fade-right">
                    <img src={imgCloudOnlineReport} className="img-fluid animated" alt="img-cloud--online-report" />
                  </div>
                  <div className="col-md-8" data-aos="fade-up">
                    <h3>{sectionTwoSubTwo.title}</h3>
                    <p className="paragraph">{sectionTwoSubTwo.paragraph} </p>
                  </div>
                </div>

                <div className="row content mt-3">
                  <div className="col-md-8" data-aos="fade-up">
                    <h3>{sectionTwoSubThree.title}</h3>
                    <p className="paragraph">{sectionTwoSubThree.paragraph} </p>
                  </div>
                  <div className="col-md-4" data-aos="fade-right">
                    <img src={imgCloudDataAnalytics} className="img-fluid animated" alt="img-cloud--data-analytics" />
                  </div>
                </div>
              </div>
            </section>

            <section className="item-expert-services section-bg-img ">
              <div className="container">
                <div className="row content">
                  <div className="col-md-12" data-aos="fade-up">
                    <h3>{sectionThree.title} </h3>
                    <p className="paragraph">{sectionThree.paragraph} </p>
                  </div>
                </div>

                <div className="row no-gutters" data-aos="fade-up">
                  {sectionThree.extraData.map((data, key) => {
                    return (
                      <div key={key} className="col-lg-6 col-md-6 content-item" data-aos="fade-up" data-aos-delay={data.delay}>
                        <p><i className="feather icon-check" /> {data.title}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          </main>
          <FooterUser />
        </div>
      );
    }
  }
}
